export enum QualityWidgetType {
    PercentageOfScatterGauge,
    PercentageOfScatterTrend,
    ScatteredTags,
    PercentageOfFlatGauge,
    PercentageOfFlatTrend,
    FlatTags,
    PercentageOfOutOfRangeGauge,
    PercentageOfOutOfRangeTrend,
    OutOfRangeTags,
    PercentageOfBadValuesGauge,
    PercentageOfBadValuesTrend,
    PercentageOfBadValuesByType,
    BadValuesMostFrequent,
    PercentageOfMissingGauge,
    PercentageOfMissingTrend,
    MissingTags,
    MissingTagsPerConnectionPoint,
    PercentageOfSuspiciousKPIGauge,
    PercentageOfSuspiciousKPITrend,
    SuspiciousKPI,
    PercentageOfInvalidKPIGauge,
    PercentageOfInvalidKPITrend,
    InvalidKPI
}